module.exports = __webpack_public_path__ + "img/41_35.81946f01.png";